import React from 'react'
import type { Icon } from 'shared/utils'
export const Salad = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'salad',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            fill={color}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <path
                d="M20.133 10.085c1.33-.692 1.847-4.197-.22-4.623 0 0 1.378-1.884 0-3.101-1.38-1.217-3.618 1.034-3.618 1.034s-1.551-1.827-3.274-1.26c-2.712.894-2.584 3.303-2.584 3.303s-2.411-.698-3.79.617 0 3.646 0 3.646-2.067-.255-2.756.897c-.688 1.153 1.033 3.254 1.033 3.254s-2.102.607-1.912 2.118c.19 1.512 1.706 2.494 1.706 2.494l-1.515 1.785 2.755 1.627 1.457-1.132c1.3 1.458 3.712 1.593 5.435.683 1.723-.91 1.43-2.594.888-2.932-.544-.339 1.524.93 3.247-.21 1.722-1.14.005-3.66.005-3.66s2.083 1.66 3.785-.894c.688-1.034.784-3.628-.641-3.646h-.001zm-2.975 1.218a28.562 28.562 0 01-5.116 1.563c-.697.818-1.421 1.617-2.142 2.417 1.127.068 2.252.19 3.37.366.287.045.444.405.375.66-.084.302-.374.42-.66.375a32.52 32.52 0 00-4.004-.37 38.952 38.952 0 00-2.138 2.614c-.17.233-.463.355-.735.192-.23-.139-.365-.5-.192-.734a39.89 39.89 0 011.76-2.2.556.556 0 01-.007-.11l.16-4.819c.022-.69 1.096-.691 1.073 0l-.121 3.67c.81-.905 1.64-1.811 2.435-2.745v-.006a38.144 38.144 0 01.123-4.472c.025-.29.226-.537.536-.537.272 0 .562.248.536.537a38.072 38.072 0 00-.14 3.184c1.27-1.637 2.356-3.394 2.965-5.405.2-.66 1.236-.376 1.036.285a15.349 15.349 0 01-1.438 3.266 22.841 22.841 0 01-1.688 2.47 28.48 28.48 0 003.727-1.239c.27-.111.591.122.66.376.084.303-.107.55-.375.66v.002z"
                fillRule="nonzero"
            />
        </svg>
    )
}
